import { render } from "./myFooter.vue?vue&type=template&id=0d0b77b1&scoped=true"
import script from "./myFooter.vue?vue&type=script&lang=js"
export * from "./myFooter.vue?vue&type=script&lang=js"

import "./myFooter.vue?vue&type=style&index=0&id=0d0b77b1&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0b77b1"]])

export default __exports__